import ServiceCRUD from '../../../services/ServiceCRUDNEWCHANNEL';
import { apiInstagramChat as http } from '../../../http';

class ConversationReportService extends ServiceCRUD {
  constructor() {
    super('configurations/channels');
  }

  async postCanal(path, canal) {
    const response = await http.post(`configurations/${path}`, canal);
    return response;
  }

  async putCanal(path, canal) {
    const response = await http.put(`configurations/${path}`, canal);
    return response;
  }

  async postFotoWebChat(pathImage, canal, id, path) {
    const response = await http.post(
      `configurations/webchat/${path}/${id}`,
      canal,
      {
        headers: {
          'content-type': 'multipart/form-data',
          'local-upload': pathImage
        }
      }
    );
    return response.status === 200;
  }

  async postImageOpenWebChat(pathImage, canal, id) {
    const response = await http.post(
      `configurations/webchat/open-chat/${id}`,
      canal,
      {
        headers: {
          'content-type': 'multipart/form-data',
          'local-upload': pathImage
        }
      }
    );
    return response.status === 200;
  }

  getWhatson() {
    return http.get(`configurations/watson`);
  }

  async getConfigTimeout() {
    return http.get(`configurations/timeout`);
  }

  // updateConfigProtocolChat(data) {
  //   return http.put(
  //     `configuracao/api/protocolo/criarProtocoloParaConversa`,
  //     data
  //   );
  // }

  // getConfigProtocolChat() {
  //   return http.get(`configuracao/api/protocolo/criarProtocoloParaConversa`);
  // }

  // updateTimeForEndConversation(time) {
  //   return http.put(`configuracao/api/encerramento/tempo`, { time });
  // }

  // getWaitingTime() {
  //   return http.get(`configuracao/api/encerramento/tempo`);
  // }
}

export default new ConversationReportService();
